<template>
  <div>
    <div class="is-position-relative height-151">
      <img :src="logo ? logo : '/static/img/default-placeholder.png'"
           class="image logo-img" alt="Logo"/>
    </div>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import getLogo from '@/services/general/getLogo';

export default {
  name: 'logoSociete',
  props: {
    societeId: {
      type: String,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      logo: null,
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.logo = await getLogo(this.societeId);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
